<template>
    <div>
        <base-crud crudName="Check-List" newText="Novo Check-List" :table="checkListTable" :columns="columns" :options="options"
            :endPoint='endPoint' :enableAdd="true" :enableEdit="true" :enableDelete="true" :enableView="false">
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

export default {
    data: function () {
        return {
            checkListTable: 'checkListTable',
            checkLists: [],
            pages: [],
            url: '',
            columns: ['id', 'name', 'category_id', 'actions'],
            tableData: ['id', 'name', 'category_id', 'actions'],
            options: {
                filterable: ['id', 'name'  ],
                filterByColumn: true,
                sortable: ['id', 'name'],
                pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    'id': 'ID',
                    'name': 'Nome',
                    'category_id': 'Categoria',
                    'actions': 'Ações'
                },
                templates: {
                    category_id: function (h, row, index) {
                        return row.category_name ? row.category_name : '';
                    }
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ['category'];

                    return this.$http
                        .get(this.url + '?' + query, requestData)
                        .then(function (response) {
                            console.log("Response:", response);
                            return response; 
                        })
                        .catch(
                            function (e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                },
            },
            endPoint: 'checklists/'
        }
    },
    methods: {
        query: function (query) {
            let columns = {
                id: 'id',
                name: 'name',
                // viewAllEvents: 'viewAllEvents',
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        }
    },
    components: {
        BaseCrud
    }
}
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckList/Crud.vue